"use client";

import { FormulaInfo } from "@/lib/tools/types";

interface FormulaDisplayProps {
  formula: FormulaInfo;
}

/**
 * Displays a formula with variable descriptions.
 * Shows the expression in a styled monospace box, then variables below.
 */
export function FormulaDisplay({ formula }: FormulaDisplayProps) {
  return (
    <div className="space-y-4">
      {/* Formula expression */}
      <div className="rounded-lg border border-border bg-secondary/50 p-4 sm:p-5 overflow-x-auto">
        <code className="font-mono text-sm sm:text-base text-foreground whitespace-nowrap sm:whitespace-normal">
          {formula.expression}
        </code>
      </div>

      {/* Variables legend */}
      <div className="space-y-3">
        <p className="text-sm font-semibold text-foreground">Where:</p>
        <div className="space-y-2">
          {formula.variables.map((variable, idx) => (
            <div key={idx} className="flex gap-4 text-sm">
              <div className="font-mono font-semibold text-brand min-w-fit">
                {variable.symbol}
              </div>
              <div className="text-foreground/90">{variable.description}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
